import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import GuideArticle from "../pages/article/page";
import DynamicArticle from "../pages/articles/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/basetao-spreadsheet-guide",
    element: <GuideArticle />,
  },
  {
    path: "/basetao-spreadsheet-template",
    element: <DynamicArticle />,
  },
  {
    path: "/basetao-spreadsheet-google-sheets",
    element: <DynamicArticle />,
  },
  {
    path: "/basetao-order-tracking-spreadsheet",
    element: <DynamicArticle />,
  },
  {
    path: "/basetao-shipping-calculator",
    element: <DynamicArticle />,
  },
  {
    path: "/basetao-review-2026",
    element: <DynamicArticle />,
  },
  {
    path: "/is-basetao-legit",
    element: <DynamicArticle />,
  },
  {
    path: "/basetao-shipping-cost-explained",
    element: <DynamicArticle />,
  },
  {
    path: "/basetao-coupon-guide",
    element: <DynamicArticle />,
  },
  {
    path: "/basetao-discount-code-guide",
    element: <DynamicArticle />,
  },
  {
    path: "/basetao-shopping-guide",
    element: <DynamicArticle />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;